import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: () => import("../components/home/Home.vue"),
  },
  {
    path: "/ffgs-simulator",
    component: () => import("../components/main/Main.vue"),
    beforeEnter: (to, from, next) => {
      if(!(from.hash === "#stepper-popup")) {
        next('/')
      } else {
        next();
      }
    },
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;